import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { reduxModuleLoaded, overrideSubscribeMatureFilter } from './actions';
const reducers = handleActions({
    [reduxModuleLoaded.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            reduxReady: true
        }),
    [overrideSubscribeMatureFilter.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            matureFilterOverrides: [
                payload.tier.deviationId,
                ...state.matureFilterOverrides
            ]
        })
}, {
    reduxReady: false,
    matureFilterOverrides: []
});
export default reducers;
